import { ApiService } from "../../../services/ApiService";
import { GET_ACTIVITY_LOGS } from "../../actionTypes";

export class activityLogsThunk {
  static getActivityNextLogs(query = "?page=1") {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`activity-logs${query}`);
        console.log("LOG", response);
        if (response.data) {
          dispatch({
            type: GET_ACTIVITY_LOGS,
            payload: response.data.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getActivityLogs() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("activity-logs");
        if (response.data) {
          dispatch({
            type: GET_ACTIVITY_LOGS,
            payload: response.data.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/activitylogs/activity.thunk.js